
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/methodology",
      function () {
        return require("private-next-pages/methodology.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/methodology"])
      });
    }
  